export const SEAT_TYPE_OPTIONS = [
    '일반 테이블 좌석 (의자 이동 가능)',
    '바닥 좌석 (방석, 온돌 등)',
    '높은 테이블 좌석(바/카운터석)',
    '소파석',
    '고정된 의자, 벤치형',
    '야외 테라스석',
    '기타',
];
export const ORDER_METHOD_OPTIONS = [
    '카운터 방문주문',
    '키오스크 주문',
    '베리어프리 키오스크 주문',
    '테이블 오더 주문',
    '자리에서 직원에게 주문',
];
export const ACCESSIBILITY_FEATURE_OPTIONS = [
    '휠체어 이용 가능한 좌석 수 3개 이상',
    '직원 도움 없이 이동 가능',
    '바닥에 턱/장애물 없음',
    '혼잡한 시간대 주의 필요',
    '아이 식기, 의자 있음',
    '반려동물 동반 가능',
    '비건메뉴 있음',
];
